import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// services
import { EventsService } from '../../core/services/events-service/events.service';
import { ProfileService } from '../../core/services/profile-service/profile.service';
var RegistrationComponent = /** @class */ (function () {
    function RegistrationComponent(route, eventsService, profileService) {
        this.route = route;
        this.eventsService = eventsService;
        this.profileService = profileService;
    }
    Object.defineProperty(RegistrationComponent.prototype, "eventDetails", {
        get: function () {
            return this.eventsService.eventData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationComponent.prototype, "maintenanceMode", {
        get: function () {
            return (this.eventDetails &&
                this.eventDetails.maintenance &&
                this.eventDetails.maintenance === true);
        },
        enumerable: true,
        configurable: true
    });
    RegistrationComponent.prototype.ngOnInit = function () {
        var _this = this;
        var eventId = this.route.snapshot.params.id;
        this.getEventData(eventId);
        this.profileSubscription = this.profileService.profile.subscribe(function (profile) {
            _this.profile = profile;
        });
    };
    RegistrationComponent.prototype.getEventData = function (eventId) {
        var _this = this;
        // this.http.get('/api/v1/events/' + eventId)
        this.eventsService.getEventData(eventId).subscribe(function (res) {
            _this.eventsService.waiver.header = res.waiver_description;
            _this.getWaiverText(res.waiver_text);
        }, function (err) {
            // TODO - show error alert
            // console.log('err =', err);
        });
    };
    RegistrationComponent.prototype.getWaiverText = function (url) {
        var _this = this;
        this.eventsService.getWaiverText(url).subscribe(function (response) {
            _this.eventsService.waiver.text = response;
        }, function (err) {
            // TODO - show alert somewhere?
            // console.log('waiver text err =', err);
        });
    };
    RegistrationComponent.prototype.getProfile = function () {
        this.profileService.getProfile().subscribe();
    };
    RegistrationComponent.prototype.ngOnDestroy = function () {
        if (this.profileSubscription) {
            this.profileSubscription.unsubscribe();
        }
    };
    return RegistrationComponent;
}());
export { RegistrationComponent };
